/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_EyebrowInputs */

const en_us2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyms`)
};

const pt_br2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academias`)
};

const es_419_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gimnasios`)
};

const pt_pt2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásios`)
};

const fr_fr2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salles`)
};

const de_de2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studios`)
};

const it_it2_gyms_eyebrow = /** @type {(inputs: Gyms_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestre`)
};

/**
* | output |
* | --- |
* | "Gyms" |
*
* @param {Gyms_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_eyebrow = /** @type {((inputs?: Gyms_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_eyebrow(inputs)
	if (locale === "es-419") return es_419_gyms_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_gyms_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_gyms_eyebrow(inputs)
	return en_us2_gyms_eyebrow(inputs)
});
export { gyms_eyebrow as "gyms.eyebrow" }